import {
  HEARING_EXPORT_FORMAT_PDF,
  HEARING_EXPORT_FORMAT_FULL_PDF,
} from './api';

export const pdfExports = (
  translator,
  downloadReport,
  canDownloadReport,
  canDownloadFullReport,
  buttonStyles,
) => {
  return [
    {
      municipalities: ['all'],
      commandBarItem: {
        key: 'downloadpdfreport',
        name: translator('pages.createHearing.downloadPdfReport'),
        iconProps: {
          iconName: 'PDF',
        },
        disabled: !canDownloadReport,
        onClick: () => downloadReport(HEARING_EXPORT_FORMAT_PDF),
        buttonStyles,
      },
    },
    {
      municipalities: ['all'],
      commandBarItem: {
        key: 'downloadfullpdfreport',
        name: translator('pages.createHearing.downloadFullPdfReport'),
        iconProps: {
          iconName: 'PDF',
        },
        disabled: !canDownloadFullReport,
        onClick: () => downloadReport(HEARING_EXPORT_FORMAT_FULL_PDF),
        buttonStyles,
      },
    },
  ];
};
